import React from 'react'
import './Footer.css'
import Wave from "../../img/wave.png"
import LinkedIn from '@iconscout/react-unicons/icons/uil-linkedin'
import Insta from '@iconscout/react-unicons/icons/uil-instagram'
import Github from '@iconscout/react-unicons/icons/uil-github'



const Footer = () => {
  return (
   <div className="footer">
    <img src={Wave} alt='' style={{width: '100%'}}/>
    <div className="f-content">
        <span>benjamindaviddawson@gmail.com</span>
        <div className="f-icons">
            <a href='https://www.instagram.com/realteamsasuke/' target={'_blank'} rel="noopener noreferrer">
            <Insta color='white' size='3rem'/>
            </a>
            <a href='https://www.linkedin.com/in/benjamin-david-dawson-2498261a3/' target={'_blank'} rel="noopener noreferrer">
            <LinkedIn color='white' size='3rem'/>
            </a>
            <a href='https://github.com/lmy-dawson' target={'_blank'} rel="noopener noreferrer">
            <Github color='white' size='3rem'/>
            </a> 
        </div>

        <div className="c-right">
          <span>Copyright © 2020 Dawson. All rights reserved</span>
        </div>
    </div>
   </div>
  )
}

export default Footer